import _slicedToArray from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import memoize from 'lodash/memoize';
import { createLoader } from '@spotify-internal/creator-data-loading';
import { webgateFetch, WEBGATE_DOMAIN } from './features/webgate-fetch';
export var endpoint = "".concat(WEBGATE_DOMAIN, "/s4x-me/v0/me");
export var currentUserLoader = createLoader(
/*#__PURE__*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_key) {
    var response, data, formatted;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return webgateFetch(endpoint);

          case 3:
            response = _context.sent;

            if (!(response.status === 401)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", null);

          case 6:
            if (response.ok) {
              _context.next = 8;
              break;
            }

            throw new Error("".concat(response.status, " ").concat(response.url));

          case 8:
            _context.next = 10;
            return response.json();

          case 10:
            data = _context.sent;
            formatted = _objectSpread({
              email: data.loginEmail
            }, data); // Logger.logSuccess(eventName);

            return _context.abrupt("return", formatted);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            // Logger.logError(eventName, error);

            /* eslint-disable-next-line */
            console.error(_context.t0); // throw error;

            return _context.abrupt("return", null);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), {
  cacheKeyFn: function cacheKeyFn() {
    return 0;
  }
});
export var fetchCurrentUser = memoize( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", currentUserLoader.load(0));

        case 1:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee2);
})));
export var useCurrentUser = function useCurrentUser() {
  var _React$useState = React.useState(undefined),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      user = _React$useState2[0],
      setUser = _React$useState2[1];

  React.useEffect(function () {
    var isMounted = true;
    fetchCurrentUser().then(function (u) {
      if (isMounted) setUser(u);
    });
    return function () {
      isMounted = false;
    };
  }, []);
  return user;
};